export const units = [
  {
    value: 'mwh',
    label: 'MWh',
  },
  {
    value: 'kwh',
    label: 'kWh',
  },
];